import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { FlowOfFunds } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface UploadPayoffConfirmationDocumentArg {
    engagementId: number;
    sourceRowId: number;
    file: File;
}

export const UploadPayoffConfirmationDocument = createAsyncThunk(
    'flowOfFunds/uploadPayoffConfirmationDocument',
    async (arg: UploadPayoffConfirmationDocumentArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const formData = new FormData();
        formData.append('file', arg.file);

        try {
            const response = await axios.post(
                `/api/FlowOfFunds/${arg.engagementId}/WireTransfers/ThirdPartyPayoffs/${arg.sourceRowId}/PayoffConfirmationDocument`,
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
            );

            if (response.status !== 200) {
                throw new Error('Failed to upload the payoff confirmation document');
            }

            return response.data as FlowOfFunds;
        } catch (error) {
            createNotification(
                'There was an error while uploading the payoff confirmation document.',
                'error'
            );
            throw error;
        }
    }
);
